import { defineComponent } from 'vue';
import EmbeddedDashboardCode from '@/presentation/components/embedded-dashboard/embedded-dashboard.code';

export default defineComponent({
	setup: () => {
		const code = new EmbeddedDashboardCode();

		return {
			dashboardUrl: code.dashboardUrl,
			tableauJWT: code.tableauJWT,
			dashboardWidth: code.dashboardWidth,
			dashboardHeight: code.dashboardHeight
		};
	}
});
